import {
  myHousfyShallowMount,
  testMyHousfyShallowMount,
} from "@/tests/unit/setup";
import SignDocumentsForm from "@/components/signDocuments/SignDocumentsForm.vue";
import FormService from "@/services/FormService";
import MyHousfyConfig from "@/services/MyHousfyConfig";

const mockedProps = {
  documentName: "test",
};

const component = (data: any = {}, props: any = {}, mocks: any = {}) => {
  return myHousfyShallowMount(SignDocumentsForm, {
    data,
    props: { ...mockedProps, ...props },
    mocks,
  });
};

describe("SignDocumentsForm", () => {
  testMyHousfyShallowMount(SignDocumentsForm);

  describe("Computed", () => {
    describe("initialStep", () => {
      it("should return correct step if status passed by props is signed", () => {
        // given
        const props = {
          status: "signed",
        };
        const expectedResult = "success";
        const wrapper = component({}, props);
        // when
        // then
        expect(wrapper.vm.initialStep).toBe(expectedResult);
      });
      it("should return correct step if status passed by props is cancelled", () => {
        // given
        const props = {
          status: "cancelled",
        };
        const expectedResult = "cancelled";
        const wrapper = component({}, props);
        // when
        // then
        expect(wrapper.vm.initialStep).toBe(expectedResult);
      });
      it("should return correct step if status passed by props is pending_to_be_signed_by_current_signer", () => {
        // given
        const props = {
          status: "pending_to_be_signed_by_current_signer",
        };
        const expectedResult = "stepsDescription";
        const wrapper = component({}, props);
        // when
        // then
        expect(wrapper.vm.initialStep).toBe(expectedResult);
      });
      it("should return correct step if status passed by props is rejected_by_current_signer", () => {
        // given
        const props = {
          status: "rejected_by_current_signer",
        };
        const expectedResult = "cancelled";
        const wrapper = component({}, props);
        // when
        // then
        expect(wrapper.vm.initialStep).toBe(expectedResult);
      });
      it("should return correct step if status passed by props is rejected_by_others", () => {
        // given
        const props = {
          status: "rejected_by_current_signer",
        };
        const expectedResult = "cancelled";
        const wrapper = component({}, props);
        // when
        // then
        expect(wrapper.vm.initialStep).toBe(expectedResult);
      });
      it("should return correct step if status passed by props is pending_to_be_signed_by_others", () => {
        // given
        const props = {
          status: "pending_to_be_signed_by_others",
        };
        const expectedResult = "pending";
        const wrapper = component({}, props);
        // when
        // then
        expect(wrapper.vm.initialStep).toBe(expectedResult);
      });
      it("should return correct step if status passed by props is signed_first_part_pending_to_send_to_second_part", () => {
        // given
        const props = {
          status: "signed_first_part_pending_to_send_to_second_part",
        };
        const expectedResult = "pending";
        const wrapper = component({}, props);
        // when
        // then
        expect(wrapper.vm.initialStep).toBe(expectedResult);
      });
      it("should return correct step if status passed by props is expired", () => {
        // given
        const props = {
          status: "expired",
        };
        const expectedResult = "expired";
        const wrapper = component({}, props);
        // when
        // then
        expect(wrapper.vm.initialStep).toBe(expectedResult);
      });
      it("should return correct step if status passed by props is no_permission", () => {
        // given
        const props = {
          status: "no_permission",
        };
        const expectedResult = "no_permission";
        const wrapper = component({}, props);
        // when
        // then
        expect(wrapper.vm.initialStep).toBe(expectedResult);
      });
      it("should return correct step if status passed by props is error", () => {
        // given
        const props = {
          status: "error",
        };
        const expectedResult = "error";
        const wrapper = component({}, props);
        // when
        // then
        expect(wrapper.vm.initialStep).toBe(expectedResult);
      });
    });
  });

  describe("Methods", () => {
    describe("goToStep", () => {
      it("should change correctly the value of vars previousStep and currentStep", () => {
        // given
        const initialStep = "stepsDescription";
        const currentStep = "iframe";
        const stepToGo = "success";
        const mockedData = {
          currentStep: currentStep,
        };
        const wrapper = component(mockedData);
        // then
        expect(wrapper.vm.previousStep).toBe(initialStep);
        expect(wrapper.vm.currentStep).toBe(currentStep);
        // when
        wrapper.vm.goToStep(stepToGo);
        // then
        expect(wrapper.vm.previousStep).toBe(currentStep);
        expect(wrapper.vm.currentStep).toBe(stepToGo);
      });
      it("should call formService with correct params", () => {
        // given
        const currentStep = "iframe";
        const stepToGo = "success";
        const formName = "test12";
        const mockedData = {
          currentStep: currentStep,
          formName: formName,
        };
        spyOn(FormService, "trackStepsFunnel");
        const wrapper = component(mockedData);
        // when
        wrapper.vm.goToStep(stepToGo);
        // then
        expect(FormService.trackStepsFunnel).toHaveBeenCalledWith(
          formName,
          stepToGo,
          currentStep
        );
      });
    });
    describe("nextFromStepsDescription", () => {
      it("should call goToStep method with correct param", () => {
        // given
        const stepToCall = "iframe";
        const wrapper = component();
        spyOn(wrapper.vm, "goToStep");
        // when
        wrapper.vm.nextFromStepsDescription();
        // then
        expect(wrapper.vm.goToStep).toHaveBeenCalledWith(stepToCall);
      });
    });

    describe("nextFromIframe", () => {
      it("should call goToStep method with correct param if status passed by params is signed", () => {
        // given
        const stepToCall = "success";
        const mockedStatus = {
          status: "signed",
        };
        const wrapper = component();
        spyOn(wrapper.vm, "goToStep");
        // when
        wrapper.vm.nextFromIframe(mockedStatus);
        // then
        expect(wrapper.vm.goToStep).toHaveBeenCalledWith(stepToCall);
      });
      it("should call goToStep method with correct param if status passed by params is canceled", () => {
        // given
        const stepToCall = "cancelled";
        const mockedStatus = {
          status: "cancelled",
        };
        const wrapper = component();
        spyOn(wrapper.vm, "goToStep");
        // when
        wrapper.vm.nextFromIframe(mockedStatus);
        // then
        expect(wrapper.vm.goToStep).toHaveBeenCalledWith(stepToCall);
      });
    });

    describe("loginToMyh", () => {
      it("should set loading to true", () => {
        // given
        const wrapper = component();
        // then
        expect(wrapper.vm.loading).toBe(false);
        // when
        wrapper.vm.loginToMyh();
        // then
        expect(wrapper.vm.loading).toBe(true);
      });
      it("should call redirectToLogin with correctUrl", () => {
        // given
        const mockedUserUuid = "1234-sad-432";
        const mockedUserPublicToken = "1hehu2h14o";
        const mockedProps = {
          userUuid: mockedUserUuid,
          userPublicToken: mockedUserPublicToken,
        };
        const myhUrl = MyHousfyConfig.config().MYHOUSFY_URL;
        const expectedUrlToSend = `${myhUrl}/login?uuid=${mockedUserUuid}&userPublicToken=${mockedUserPublicToken}&next=/dashboard/documentos`;

        const wrapper = component({}, mockedProps);
        spyOn(wrapper.vm, "redirectToUrl");
        // when
        wrapper.vm.loginToMyh();

        // then
        expect(wrapper.vm.redirectToUrl).toHaveBeenLastCalledWith(
          expectedUrlToSend
        );
      });
    });
  });
});
